export const URLS = {
	WORKOUT: import.meta.env.VITE_WORKOUT,
	CHAT: import.meta.env.VITE_CHAT,
	MEDIA: import.meta.env.VITE_MEDIA,
	KC_URL: import.meta.env.VITE_KC_URL,
	KC_REALM: import.meta.env.VITE_KC_REALM,
	KC_USER: import.meta.env.VITE_KC_USER,
	BUILD_TIME_MOSCOW: import.meta.env.VITE_BUILD_TIME_MOSCOW,
	GIT_COMMIT: import.meta.env.VITE_GIT_COMMIT,
	APP_VERSION: import.meta.env.VITE_APP_VERSION,
}
